export default "__VITE_ASSET__rX4SKQlO__"